var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex justify-between" }, [
    _c("div", { staticClass: "w-full flex max-w-2xl" }, [
      _c("div", { staticClass: "relative w-full" }, [
        _c(
          "div",
          {
            staticClass:
              "flex absolute opacity-50 right-0 h-full items-center p-2"
          },
          [
            _vm.searchQuery.length > 0
              ? _c(
                  "button",
                  {
                    attrs: {
                      title: _vm.$t(
                        _vm.clearSearchTitle.key,
                        _vm.clearSearchTitle.attr
                      )
                    },
                    on: { click: _vm.reset }
                  },
                  [
                    _c("icon", {
                      attrs: {
                        "aria-hidden": "true",
                        type: "close",
                        color: _vm.brandDark,
                        size: 24
                      }
                    })
                  ],
                  1
                )
              : _c("icon", {
                  staticClass: "pointer-events-none",
                  attrs: {
                    "aria-hidden": "true",
                    type: "search",
                    color: _vm.brandDark,
                    size: 24
                  }
                })
          ],
          1
        ),
        _c("input", {
          staticClass: "input px-4 p-2 w-full rounded-sm text-sm mr-2 shadow",
          style: _vm.inputStyle,
          attrs: {
            type: "text",
            placeholder: _vm.$t("TRANSCRIPTS.PLACEHOLDER"),
            "data-test": "tab-transcripts--search",
            title: _vm.$t(_vm.searchTitle.key, _vm.searchTitle.attr)
          },
          domProps: { value: _vm.searchQuery },
          on: { input: _vm.search }
        })
      ]),
      _vm.searchControls
        ? _c(
            "div",
            {
              staticClass: "flex items-center p-2",
              attrs: { "data-test": "tab-transcripts--search-controls" }
            },
            [
              _vm.noResults
                ? _c(
                    "div",
                    {
                      staticClass: "whitespace-no-wrap truncate",
                      attrs: {
                        "data-test":
                          "tab-transcripts--search-controls--no-results"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("TRANSCRIPTS.NO_SEARCH_RESULTS")))]
                  )
                : _c("div", { staticClass: "flex flex-no-wrap w-32" }, [
                    _c(
                      "button",
                      {
                        staticClass: "block px-0 tablet:px-1 desktop:px-2",
                        attrs: {
                          "data-test":
                            "tab-transcripts--search-controls--previous",
                          title: _vm.$t(
                            _vm.previousSearchTitle.key,
                            _vm.previousSearchTitle.attr
                          )
                        },
                        on: { click: _vm.previousSearchResult }
                      },
                      [
                        _c("icon", {
                          attrs: { "aria-hidden": "true", type: "chevron-left" }
                        })
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "whitespace-no-wrap block stepper",
                        attrs: {
                          "data-test": "tab-transcripts--search-results"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            attrs: {
                              "data-test":
                                "tab-transcripts--search-controls--current-result"
                            }
                          },
                          [_vm._v(_vm._s(_vm.searchSelected))]
                        ),
                        _c(
                          "span",
                          { staticClass: "px-0 tablet:px-1 desktop:px-2" },
                          [_vm._v("/")]
                        ),
                        _c(
                          "span",
                          {
                            attrs: {
                              "data-test":
                                "tab-transcripts--search-controls--total-result",
                              title: _vm.searchResults.length
                            }
                          },
                          [_vm._v(_vm._s(_vm.results))]
                        )
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "block px-0 tablet:px-1 desktop:px-2",
                        attrs: {
                          "data-test": "tab-transcripts--search-controls--next",
                          title: _vm.$t(
                            _vm.nextSearchTitle.key,
                            _vm.nextSearchTitle.attr
                          )
                        },
                        on: { click: _vm.nextSearchResult }
                      },
                      [
                        _c("icon", {
                          attrs: {
                            "aria-hidden": "true",
                            type: "chevron-right"
                          }
                        })
                      ],
                      1
                    )
                  ])
            ]
          )
        : _vm._e()
    ]),
    _c(
      "button",
      {
        staticClass:
          "block rounded-sm whitespace-no-wrap text-sm px-4 py-2 ml-2 border w-32 shadow",
        class: { "mobile:hidden": _vm.searchControls },
        style: _vm.buttonStyle,
        attrs: {
          "data-test": "tab-transcripts--follow",
          title: _vm.$t(
            _vm.followTranscriptsTitle.key,
            _vm.followTranscriptsTitle.attr
          )
        },
        on: { click: _vm.toggleFollow }
      },
      [
        _vm._v(
          _vm._s(
            _vm.follow
              ? _vm.$t("TRANSCRIPTS.FOLLOW.ACTIVE")
              : _vm.$t("TRANSCRIPTS.FOLLOW.INACTIVE")
          )
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }